import PatientFetcher from './patient-fetcher'

export default PatientFetcher
